/*
Author : Jérome Lachaud

Markup :
<div class="js-share">
<a href=" " data-share-provider="">
</div>

Setup :
$(function() {
	$(".js-share").sharing();
});

*/

;(function ( $, window, document, undefined ) {
    var pluginName = "sharing",
        defaults = {};

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

		init: function() {
			this.setElements();
			this.setVars();
			this.setEvents();
		},

		setElements: function() {
			this.$element = $(this.element);
		},

		setVars: function() {
			this.url = $("meta[property='og:url']").attr("content");
			this.title = (this.$element.data("share-txt")) ? this.$element.data("share-txt") : $("meta[property='og:title']").attr("content");
			this.description = $("meta[property='og:description']").attr("content");
			this.image = $("meta[property='og:image']").attr("content");
			this.provider = this.$element.data("share");
		},

		setEvents: function() {
			this.$element.on("click", $.proxy(this.share, this));
		},

		share: function(e) {
			if (this.provider == "facebook") {
				var shareUrl = "http://www.facebook.com/sharer.php?s=100&p[title]="+ encodeURIComponent(this.title) +"&p[url]=" + encodeURIComponent(this.url) +"&p[images][0]="+ this.image +"&p[summary]=";
			}
			else if (this.provider == "twitter") {
				var shareUrl = "https://twitter.com/share?url=" + encodeURIComponent(this.url) + "&text=" + encodeURIComponent(this.title) + "&via=francefootball";
			}

			var width = 638;
			var popupX = (screen.availWidth / 2) - (width / 2);
			var height = 450;
			var popupY = (screen.availHeight / 2) - (height / 2);
			var sharePopup = window.open(shareUrl, this.provider, "width="+ width +",height="+ height +",left="+ popupX +",top="+ popupY);

			e.preventDefault();
		},

	});

    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName,
                new Plugin( this, options ));
            }
        });
    };

})( jQuery, window, document );
